import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import PillGroup from './PillGroup';
import UploadBox from './UploadBox';
import { apiConstants } from '../../../../utils/apiConstants';
import { SHOW_TYPES, YES_NO_OPTIONS } from './createScriptUtils';
import InputFieldV2 from '../../../../lib/input/InputFieldV2';
import DropDownV2 from '../../../../global/ui/DropDownV2';
import { emptyFunction } from '../../../../utils';
import DatePickerV2 from '../../../../global/ui/DatePickerV2';
import { DateUtils } from '../../../../utils/dateUtils';
import moment from 'moment';

const ShowDetailsStep = ({ onBrowseImages, selectedCoverImg, selectedLocImg, fromData, onCoverFileSelected, resetOtherData }: any) => {

    const { control, watch } = useFormContext();

    const showType = watch(apiConstants.show_type);
    const addLocationsToVault = watch(apiConstants.add_locations_to_vault);
    const isTvShow = showType === 'tv_show';

    return (
        <div className="cs-step">
            <h3 className="cs-step__title">Type of show you are working on</h3>
            <div className="cl-step__fields">
                <Controller
                    name={apiConstants.show_type}
                    control={control}
                    render={({ field }) => (
                        <PillGroup
                            name="show_type"
                            options={SHOW_TYPES}
                            value={field.value}
                            onChange={(evt: any) => {
                                field.onChange?.(evt);
                                setTimeout(() => {
                                    fromData.setValue(apiConstants.number_of_scenes, '', { shouldValidate: true, })
                                    fromData.setValue(apiConstants.number_of_episodes, '', { shouldValidate: true, })
                                    resetOtherData?.();
                                }, 300)
                            }}
                        />
                    )}
                />
                <InputFieldV2
                    name={apiConstants.name}
                    label="Name of script"
                    placeholder="Enter name"
                    rules={{ required: 'Script name is required' }}
                />
                {isTvShow
                    ?
                    <InputFieldV2
                        name={apiConstants.number_of_episodes}
                        label="Number of episodes"
                        placeholder="Enter number of episodes"
                        rules={{
                            required: 'Number of episodes is required.',
                            min: {
                                value: 1,
                                message: 'Number of episodes must be greater than 0.',
                            },
                            max: {
                                value: 100,
                                message: 'Number of episodes cannot exceed 100.',
                            },
                            validate: (value: any) => Number.isInteger(Number(value)) || 'Only numbers are allowed.',
                        }}
                    />
                    :
                    <InputFieldV2
                        name={apiConstants.number_of_scenes}
                        label="Number of scenes"
                        placeholder="Enter number of scenes"
                        rules={{
                            required: 'Number of scenes is required.',
                            min: {
                                value: 1,
                                message: 'Number of scenes must be greater than 0.',
                            },
                            max: {
                                value: 100,
                                message: 'Number of scenes cannot exceed 100.',
                            },
                            validate: (value: any) => Number.isInteger(Number(value)) || 'Only numbers are allowed.',
                        }}
                    />
                }
                <hr className="cs-divider" />
                {/* <h3 className="cs-step__title">Add locations to your studios vault?</h3>
                <Controller
                    name={apiConstants.add_locations_to_vault}
                    control={control}
                    render={({ field }) => (
                        <PillGroup
                            name="add_locations_to_vault"
                            options={YES_NO_OPTIONS}
                            value={field.value}
                            onChange={field.onChange}
                        />
                    )}
                /> */}

                {/* {addLocationsToVault && (
                    <Controller
                        name={apiConstants.locations_date}
                        control={fromData.control}
                        rules={{ required: 'Please pick a date' }}
                        render={({ field, fieldState }) => {
                            return (
                                <DatePickerV2
                                    date={field?.value ? moment(field?.value, 'DD/MM/YYYY') : null}
                                    onDateChange={d => fromData.setValue(apiConstants.locations_date, DateUtils.formatDateTime(d, 'DD/MM/YYYY'), { shouldValidate: true, })}
                                    label="Date"
                                    placeholder="Select date"
                                    openDirection="up"
                                    allowPastDate
                                    errorMessage={fieldState?.error?.message || ''}
                                    rightIcon='/assets/images/calendar1.svg'
                                />
                            )
                        }}
                    />
                )} */}

                {/* <hr className="cs-divider" /> */}

                {/* 

                <h3 className="cs-step__title">Create photo folders for locations and set builds?</h3>
                <p className="cs-step__subtext">Set photos will not be added to a studio&apos;s vault.</p>
                <Controller
                    name={apiConstants.create_photo_folders}
                    control={control}
                    render={({ field }) => (
                        <PillGroup
                            name="create_photo_folders"
                            options={YES_NO_OPTIONS}
                            value={field.value}
                            onChange={field.onChange}
                        />
                    )}
                />

                <hr className="cs-divider" /> */}

                <h3 className="cs-step__title">Assign script cover image</h3>
                {isTvShow && <p style={{ marginTop: '-15px', marginBottom: '-12px' }} className="cs-step__subtext">Upload here or assign photo from a location</p>}

                <div className={`cs-upload-row cs-upload-row--split`}>
                    <UploadBox
                        icon="upload"
                        title="Upload Cover Image"
                        subtitle="9:16 recommended"
                        previewUrl={selectedCoverImg?.image}
                        onFile={onCoverFileSelected}
                    />
                    {isTvShow
                        ?
                        <UploadBox
                            icon="search"
                            title="Browse Location Images"
                            subtitle=''
                            onClick={onBrowseImages}
                            previewUrl={selectedLocImg?.image}
                            onFile={emptyFunction}
                        />
                        :
                        <button style={{ opacity: 0 }} type="button" className="cs-upload-box" />
                    }

                </div>
            </div>
        </div>
    );
};

export default ShowDetailsStep;